import { SBModel, SBModelUlid } from './SBmodel'

export interface Answer extends SBModelUlid {
  message: string
  percentage: number
  forFollower: boolean
  buttons?: AnswerButtons[]
  attachments?: AnswerAttachment[]
}
export interface AnswerButtons extends SBModel {
  title: string
  url: string
}
export interface AnswerAttachment extends SBModel {
  name: string
  extension: string
  size: string
  url: string
  downloadUrl: string
}
export interface AnswerAttachmentType extends SBModel {
  name: string
  extensions: string[]
  maxSize: number
  accept: string[]
}

export interface AnswerAnalytics {
  sent: number
  read: number
}

/**
 * Extension as per Instagram specifications
 *
 * https://developers.facebook.com/docs/instagram-platform/instagram-api-with-instagram-login/messaging-api#send-an-image-or-gif
 */
export const attachmentTypes: AnswerAttachmentType[] = [
  {
    id: 0,
    name: 'Picture',
    extensions: ['png', 'jpeg', 'gif'],
    maxSize: 8388608, // 8Mb
    accept: ['image/png', 'image/jpeg', 'image/gif'],
  },
  {
    id: 1,
    name: 'Video',
    extensions: ['mp4', 'ogg', 'avi', 'mov', 'webm'],
    maxSize: 26214400, // 25Mb
    accept: [
      'video/mp4',
      'video/ogg',
      'video/x-msvideo',
      'video/quicktime',
      'video/webm',
    ],
  },
  {
    id: 2,
    name: 'Audio',
    extensions: ['aac', 'm4a', 'waw', 'mp4'],
    maxSize: 26214400, // 25Mb
    accept: ['audio/aac', 'audio/mp4', 'audio/wav', 'audio/mp4'],
  },
]

export const formatBytes = (bytes: number): string => {
  const units = ['octets', 'Ko', 'Mo', 'Go', 'To']
  let index = 0

  while (bytes >= 1024 && index < units.length - 1) {
    bytes /= 1024
    index++
  }

  return `${bytes.toFixed(0)} ${units[index]}`
}
